<script>
    import Button from '../UI/Button.svelte';
    import {createEventDispatcher} from 'svelte';
    export let seedName;
    export let plantName;
    export let description;
  const dispatch = createEventDispatcher();
</script>

<style>
    article {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
      border-radius: var(--space-8x);
      background: white;
      margin: 0rem;
      outline: 3px solid black;
      margin-top: var(--space-2x);
      max-height: 80vh;

    }
  
    header,
    footer {
      padding: 1rem;
    }
  
    .image {
      width: 100%;
      height: 14rem;
      
    }

    .description {
      text-align: left;
      padding: 1rem;

    }


  </style>

<article>
    <header>
        <div class="referal-cta">   
            <!-- <Button
                mode="outline"
              on:click={() => dispatch('buy-now', id)} >Save</Button> -->
              <h1>
                {seedName}
            </h1>
          </div>

    </header>
    <div class= "description">
        {description}
    </div>
    <footer>
    </footer>
</article>